import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
};

export const content: SxStyle = {
  background: (p) => p.palette.common.white,
  px: 1,
  py: 0.5,
};

export const itemWrapper: SxStyle = {
  px: 2,
  pb: 5,
  pt: 2.5,
};

export const chartGroup: SxStyle = {
  pt: 2,
  pb: 2,
  pl: 5,
  position: 'relative',
};

export const chartGroupLabel: SxStyle = {
  position: 'absolute',
  left: (p) => p.spacing(13.5),
  top: (p) => p.spacing(9),
};

export const Label: SxStyle = {
  fontSize: (p) => p.typography.h5.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
};

export const description: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  color: (p) => p.palette.grey[500],
  width: (p) => p.spacing(10),
  textAlign: 'center',
};
